import { Navigate, useParams, useSearchParams } from "react-router";

/**
 * `/app/sozlesmeler/:id/metin` → `/app/sozlesmeler/:id/belge`
 *
 * Metin artık ayrı bir ekran değil, "Belge" bölümünün kendisi. Eski adres SİLİNMEDİ çünkü
 * dışarıda yaşıyor: bildirim e-postaları, kullanıcıların kaydettiği bağlantılar ve E2E
 * senaryoları doğrudan oraya gidiyor. Kırık bir adres bırakmak, taşımanın bedelini
 * kullanıcıya ödetmek olurdu.
 *
 * ⚠ Geliş bağlamı (`?liste=`) KORUNUYOR: kullanıcı daraltılmış listeye dönebilmeli.
 * ⚠ `replace`: geri tuşu kullanıcıyı yönlendirmenin içine geri sokmasın.
 */
export function MetinYonlendirmesi() {
  const { id = "" } = useParams();
  const [params] = useSearchParams();
  const liste = params.get("liste");
  return (
    <Navigate
      replace
      to={`/app/sozlesmeler/${id}/belge${liste ? `?liste=${encodeURIComponent(liste)}` : ""}`}
    />
  );
}
